<div class="journalMain">
  <header class="journalMain__header innerContainer">
    <vc-journal-main-breadcrumb
      [currentCategory]="currentCategory"
      class="journalMain__breadcrumb"
    ></vc-journal-main-breadcrumb>
    <h1 class="journalMain__title vc-title-s">
      <ng-container *ngIf="currentCategory.id === defaultCategory.id; else categorysTitle" i18n="@@JOURNAL_MAIN.TITLE"
        ><span>Le journal</span></ng-container
      >
      <ng-template #categorysTitle
        ><span>{{ currentCategory.title }}</span></ng-template
      >
      <span *ngIf="currentCategory.id !== '' && currentPage > 1" class="journalMain__title__page vc-text-s">
        P{{ currentPage }}
      </span>
    </h1>
    <ng-container [ngSwitch]="currentCategory.id">
      <p
        *ngSwitchCase="'inside-vestiaire'"
        class="journalMain__intro vc-text-l"
        i18n="@@JOURNAL_MAIN.INTRO_INSIDE_VESTIAIRE"
      >
        Discover more about how Vestiaire Collective works behind the scenes, and explore the personalities and
        wardrobes that make up our wonderful teams across the world.
      </p>
      <p
        *ngSwitchCase="'how-to-style-it'"
        class="journalMain__intro vc-text-l"
        i18n="@@JOURNAL_MAIN.INTRO_HOW_TO_STYLE_IT"
      >
        There's an art to style. Luckily we know a thing or two, and we're happy to share it with you! Explore all the
        latest seasonal ideas for wearing and rewearing your favourite pieces.
      </p>
      <p
        *ngSwitchCase="'labels-we-love'"
        class="journalMain__intro vc-text-l"
        i18n="@@JOURNAL_MAIN.INTRO_LABELS_WE_LOVE"
      >
        Whether it's an international catwalk brand or a local indie label, join us as we delve deeper into the brands
        that we (and you) can't get enough of.
      </p>
      <p
        *ngSwitchCase="'sustainability'"
        class="journalMain__intro vc-text-l"
        i18n="@@JOURNAL_MAIN.INTRO_SUSTAINABILITY"
      >
        We know you're into circular fashion, that's one of the reasons why you're here. Discover more about
        sustainability and how we can all do our bit to change the fashion industry for the better.
      </p>
      <p
        *ngSwitchCase="'fashion-stories'"
        class="journalMain__intro vc-text-l"
        i18n="@@JOURNAL_MAIN.INTRO_FASHION_STORIES"
      >
        Direct from our style team, explore the style of lesser-known cult icons, and see the pieces that they have on
        their wishlists this season.
      </p>
      <p *ngSwitchCase="'my-community'" class="journalMain__intro vc-text-l" i18n="@@JOURNAL_MAIN.INTRO_MY_COMMUNITY">
        At Vestiaire Collective, we couldn't do what we do without our community. From Professional Sellers to niche
        specialists, to cool members from across the globe, we meet the people that make Vestiaire special.
      </p>
      <p *ngSwitchCase="'promotions'" class="journalMain__intro vc-text-l" i18n="@@JOURNAL_MAIN.INTRO_PROMOTIONS">
        Feeling lucky? This is the place to find super deals and top discounts on special pieces, play one of our
        infamous competitions, or simply get involved and win yourself a big prize.
      </p>
      <p
        *ngSwitchCase="'fashion-report'"
        class="journalMain__intro vc-text-l"
        i18n="@@JOURNAL_MAIN.INTRO_FASHION_REPORT"
      >
        As experts in our field, we know a thing our two about the world of sustainable, second-hand fashion. And what's
        more, we love sharing our knowledge with our community! Here you'll discover our fascinating in-depth reports
        from the front lines of fashion.
      </p>
      <p *ngSwitchDefault class="journalMain__intro vc-text-l" i18n="@@JOURNAL_MAIN.INTRO">
        Welcome to Vestiaire Collective! We're very happy to see you. Here you'll discover our unique take on fashion,
        style and sustainability. So, let's dive in!
      </p>
    </ng-container>
    <div class="journalMain__search vc-formUnit" *ngIf="false">
      <vc-sprite-icons name="search" class="journalMain__search__icon"></vc-sprite-icons>
      <input
        type="text"
        name="journal_search"
        class="vc-inputText journalMain__search__input"
        i18n-placeholder="@@JOURNAL_MAIN.SEARCH.PLACEHOLDER"
        placeholder="Search by article, category, sub-category..."
      />
    </div>
  </header>
  <nav
    *ngIf="categoryList"
    class="journalMain__categories"
    id="navigation"
    itemscope="itemscope"
    itemtype="https://schema.org/SiteNavigationElement"
    role="navigation"
  >
    <ul class="journalMain__categories__list">
      <li class="journalMain__categories__item">
        <vc-ref
          [extraClass]="
            currentCategory.id === defaultCategory.id
              ? 'vc-btn vc-btn--medium vc-btn--chip active'
              : 'vc-btn vc-btn--medium vc-btn--chip'
          "
          (click)="updateCurrentCategory($event, defaultCategory)"
          resource="/journal/"
          i18n="@@JOURNAL_MAIN.CATEGORY_LIST.DEFAULT"
          >All</vc-ref
        >
      </li>
      <li *ngFor="let category of categoryList" class="journalMain__categories__item">
        <vc-ref
          [extraClass]="
            currentCategory.id === category.id
              ? 'vc-btn vc-btn--medium vc-btn--chip active'
              : 'vc-btn vc-btn--medium vc-btn--chip'
          "
          (click)="updateCurrentCategory($event, category)"
          resource="/journal/cat/{{ category?.uri }}/"
          >{{ category?.title }}</vc-ref
        >
      </li>
    </ul>
  </nav>
  <section class="journalMain__articles">
    <ng-container *ngIf="postList.length > 0; else empty">
      <div class="innerContainer journalMain__articles__list" #showMore>
        <ul class="row row--gutter24 row-md--gutter24">
          <li *ngFor="let post of postList" class="journalMain__articles__item col-12 col-md-4">
            <vc-post [blockPost]="post"></vc-post>
          </li>
        </ul>
        <vc-journal-main-pagination
          class="journalMain__articles__pagination innerContainer"
          [pages]="articlesPagination"
        ></vc-journal-main-pagination>
      </div>
    </ng-container>
    <ng-template #empty>
      <div class="innerContainer journalMain__articles__empty">
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="journalMain__articles__empty__icon"
        >
          <circle cx="28" cy="28" r="27.25" stroke="#282828" stroke-width="1.5" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.3846 37.625V18.375H35.6154V37.625H20.3846ZM19 17.6875C19 17.3078 19.31 17 19.6923 17H36.3077C36.69 17 37 17.3078 37 17.6875V38.3125C37 38.6922 36.69 39 36.3077 39H19.6923C19.31 39 19 38.6922 19 38.3125V17.6875ZM32.6419 28.6669H24.1715C23.9915 28.6669 23.8462 28.5225 23.8462 28.3431C23.8462 28.165 23.9915 28.0206 24.1715 28.0206H32.6419C32.8226 28.0206 32.968 28.165 32.968 28.3431C32.968 28.5225 32.8226 28.6669 32.6419 28.6669ZM29.9345 22.4794H32.8462C33.0268 22.4794 33.1722 22.335 33.1722 22.1556C33.1722 21.9775 33.0268 21.8331 32.8462 21.8331H29.9345C29.7545 21.8331 29.6091 21.9775 29.6091 22.1556C29.6091 22.335 29.7545 22.4794 29.9345 22.4794ZM32.8462 24.5419H29.9345C29.7545 24.5419 29.6091 24.3975 29.6091 24.2181C29.6091 24.04 29.7545 23.8956 29.9345 23.8956H32.8462C33.0268 23.8956 33.1722 24.04 33.1722 24.2181C33.1722 24.3975 33.0268 24.5419 32.8462 24.5419ZM24.1715 31.4169H32.6419C32.8226 31.4169 32.968 31.2725 32.968 31.0931C32.968 30.915 32.8226 30.7706 32.6419 30.7706H24.1715C23.9915 30.7706 23.8462 30.915 23.8462 31.0931C23.8462 31.2725 23.9915 31.4169 24.1715 31.4169ZM30.565 34.1669H24.1715C23.9915 34.1669 23.8462 34.0225 23.8462 33.8431C23.8462 33.665 23.9915 33.5206 24.1715 33.5206H30.565C30.7457 33.5206 30.8911 33.665 30.8911 33.8431C30.8911 34.0225 30.7457 34.1669 30.565 34.1669ZM22.5836 28.0203C22.4036 28.0203 22.2575 28.1653 22.2575 28.3441C22.2575 28.5222 22.4036 28.6672 22.5836 28.6672C22.7636 28.6672 22.909 28.5222 22.909 28.3441C22.909 28.1653 22.7636 28.0203 22.5836 28.0203ZM28.0204 22.1566C28.0204 21.9778 28.1665 21.8328 28.3465 21.8328C28.5265 21.8328 28.6719 21.9778 28.6719 22.1566C28.6719 22.3347 28.5265 22.4797 28.3465 22.4797C28.1665 22.4797 28.0204 22.3347 28.0204 22.1566ZM28.3465 23.8953C28.1665 23.8953 28.0204 24.0403 28.0204 24.2191C28.0204 24.3972 28.1665 24.5422 28.3465 24.5422C28.5265 24.5422 28.6719 24.3972 28.6719 24.2191C28.6719 24.0403 28.5265 23.8953 28.3465 23.8953ZM22.2575 31.0941C22.2575 30.9153 22.4036 30.7703 22.5836 30.7703C22.7636 30.7703 22.909 30.9153 22.909 31.0941C22.909 31.2722 22.7636 31.4172 22.5836 31.4172C22.4036 31.4172 22.2575 31.2722 22.2575 31.0941ZM22.5836 33.5203C22.4036 33.5203 22.2575 33.6653 22.2575 33.8441C22.2575 34.0222 22.4036 34.1672 22.5836 34.1672C22.7636 34.1672 22.909 34.0222 22.909 33.8441C22.909 33.6653 22.7636 33.5203 22.5836 33.5203ZM23.1538 21.8125H25.9231V24.5625H23.1538V21.8125ZM22.4615 21.8125C22.4615 21.4328 22.7715 21.125 23.1538 21.125H25.9231C26.3054 21.125 26.6154 21.4328 26.6154 21.8125V24.5625C26.6154 24.9422 26.3054 25.25 25.9231 25.25H23.1538C22.7715 25.25 22.4615 24.9422 22.4615 24.5625V21.8125Z"
            fill="#1E1E1E"
          />
        </svg>

        <h2 class="journalMain__articles__empty__title" i18n="@@JOURNAL_MAIN.EMPTY.TITLE">No Article</h2>
        <p class="journalMain__articles__empty__text" i18n="@@JOURNAL_MAIN.EMPTY.TEXT">
          There is no article in “{{ currentCategory.title }}” at this time.
        </p>
      </div>
    </ng-template>
    <div *ngIf="pending" class="journalMain__articles__loader">
      <vc-loader></vc-loader>
    </div>
  </section>
</div>
